import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const setSuiteFormData = (state, { payload }) => {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload
    },
  };
};

const clearSuiteFormData = (state) =>{
  return {
    ...state,
    data:{}
  }
}

const initialState = {};

export default createReducer(initialState, {
  [TYPES.SET_SUITE_FORM_DATA]: setSuiteFormData,
  [TYPES.CLEAR_SUITE_FORM_DATA]: clearSuiteFormData
});
